module.exports = __webpack_public_path__ + "img/Polygon 2.4a73e1c6.svg";